import React, {Component} from 'react';

import Message from './auth/message'
import Login from './auth/login'
import Signup from './auth/signup'
import Reset from './auth/reset'

class Account extends React.Component {

	constructor ( props ) {
		super();
		this.state = {
			view: 'message',
			optoutMarketing: false
		};
	}


	handleViewChange = ( view, event ) => {
		event.preventDefault();
		this.setState({ view: view });
	}

	handleMarketingOptout = ( event ) => {
		this.setState({ optoutMarketing: event.target.checked });
	}

	handleFacebookLogin = ( event ) => {
		event.preventDefault();
		const width = 400;
		const height = 600;
		const left = (screen.width/2)-(width/2);
		const top = (screen.height/2)-(height/2);
		this.externalWindow = window.open( "/facebook-login?" + this.getRedirectUrl(), 'oauthFB', "menubar=no,status=no,width=" + width + ",height=" + height + ",toolbar=no,left=" + left + ",top=" + top );
	}

	getRedirectUrl = () => {

		const formData = {...this.props.params};
		const url = this.props.product.url + `/booking`;
		formData.date = formData.date.format('DD/MM/YYYY');

		const params = [];
		params.push( 'redirect[path]=' + url );
		Object.keys( formData ).map(function(key) {
			params.push( 'redirect[' + encodeURI( key ) + ']=' + encodeURI( formData[key] ) );
		});
		params.push( 'redirect[optout_marketing]=' + ( this.state.optoutMarketing ? 1 : 0 ) );
		params.push( 'redirect[view]=extended' );
		return params.join('&');
	}

	render() {

		const supplierImage = this.props.product.supplier.image != null && this.props.product.supplier.image.length ? { backgroundImage: "url(" + this.props.product.supplier.image  + ")" }: {};

		return (
			<div className="authDetail fb-signup">
				<div className="grid-x grid-margin-x">
					<div className="cell small-3 large-2">
						<div className="img-circular" style={supplierImage}></div>
					</div>
					<div className="cell small-8 large-9 productDetails new">
						<h1>Enquiry for {this.props.product.name}</h1>
						<p style={{marginBottom: '0.5rem'}}>For <strong>{this.props.params.pax}</strong> people on <strong>{this.props.params.date != null ? this.props.params.date.format('DD/MM/YYYY') : null}</strong> at <strong>{this.props.params.time}</strong></p>
						<div className="label-red">Likely to sell out</div>
					</div>
					
				</div>
				<div className="inner-container">

					{this.state.view == 'signup' ? (
						<Signup token={this.props.token}
							params={this.props.params}
							token={this.props.token}
							optoutMarketing={this.state.optoutMarketing}
							handleMarketingOptout={this.handleMarketingOptout}
							handleViewChange={this.handleViewChange}
							handleFacebookLogin={this.handleFacebookLogin}
							handleAuthSuccess={this.props.handleAuthSuccess}
					/>
					) : this.state.view == 'reset' ? (
						<Reset
							token={this.props.token}
							handleViewChange={this.handleViewChange}
						/>
					) : this.state.view == 'login' ? (
						<Login
							token={this.props.token}
							handleViewChange={this.handleViewChange}
							handleFacebookLogin={this.handleFacebookLogin}
							handleAuthSuccess={this.props.handleAuthSuccess}
						/>
					) : (
						<Message
							product={this.props.product}
							params={this.props.params}
							optoutMarketing={this.state.optoutMarketing}
							handleBookingInput={this.props.handleBookingInput}
							handleMarketingOptout={this.handleMarketingOptout}
							handleFacebookLogin={this.handleFacebookLogin}
							handleViewChange={this.handleViewChange}
							
						/>
					)}

				</div>
			</div>
		)
	}
}
export default Account;
